/* eslint-disable no-param-reassign */
import { createActionTypeReducer } from 'util/reducers'
import {
  FETCH_CANNED_REPLY_VARIABLES_STARTED,
  FETCH_CANNED_REPLY_VARIABLES_SUCCESS,
  FETCH_CANNED_REPLY_VARIABLES_FAILED,
} from '../types'

export const defaultState = {
  isLoading: false,
  isLoaded: false,
  hasError: false,
}

export default createActionTypeReducer(
  {
    [FETCH_CANNED_REPLY_VARIABLES_STARTED]: draftState => {
      draftState.isLoading = true
      return draftState
    },
    [FETCH_CANNED_REPLY_VARIABLES_SUCCESS]: draftState => {
      draftState.isLoading = false
      draftState.isLoaded = true
      draftState.hasError = false
      return draftState
    },
    [FETCH_CANNED_REPLY_VARIABLES_FAILED]: draftState => {
      draftState.isLoading = false
      draftState.hasError = true
      return draftState
    },
  },
  defaultState
)
